import { render } from "./AddHorse.ce.vue?vue&type=template&id=a40c6482"
import script from "./AddHorse.ce.vue?vue&type=script&lang=js"
export * from "./AddHorse.ce.vue?vue&type=script&lang=js"

import _style_0 from "./AddHorse.ce.vue?vue&type=style&index=0&id=a40c6482&inline&lang=css"

import exportComponent from "D:\\Projects\\Breednet\\breednet-frontend\\breednet-blackbook-frontend-master\\Components\\add-horse-btn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__